import React, { useState, useEffect } from 'react'
import './ForeFlight.css'
import PortalHeader from '../../../client-dashboard/clientNavbar/PortalHeader';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../Auth';

// Icons
import { RiSortAlphabetAsc, RiSortAlphabetDesc } from "react-icons/ri";
import { IoClose } from "react-icons/io5";

// Assets
import foreFlightBanner from '../../client-dashboard-assets/product-suit-assets/fore-flight-banner.jpg'
import foreFlightGif from '../../client-dashboard-assets/product-suit-assets/ForeFlight Dashboard GIF.gif'
import foreFlightPdf from '../../client-dashboard-assets/product-suit-assets/ForeFlightFlowchart.pdf';

const ForeFlight = () => {

  // Ensure the page always start at the top
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  const [emails, setEmails] = useState<string[]>([]);
  const [hrl, setHrl] = useState<string>();
  const [dailyEmail, setDailyEmail] = useState<boolean>();
  const [searchTerm, setSearchTerm] = useState('');
  const [sortAsc, setSortAsc] = useState(true);
  const { organization, coverage_area } = useAuth();
  
  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await fetch('/portal/api/foreflight-emails/', {
          credentials: 'same-origin' // ensures cookies/session are sent for auth
        });

        const data = await response.json();

        if (response.ok && data.emails) {
          setEmails(data.emails);
          setHrl(data.hrl);
          setDailyEmail(data.empty_email);
        } else {
          console.error("Failed to load emails:", data.error || response.statusText);
        }
      } catch (error) {
        console.error("❌ Error fetching emails:", error);
      }
    };

    fetchEmails();
  }, []);

  const filteredEmails = emails.filter(email =>
    email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedFilteredEmails = [...filteredEmails].sort((a, b) =>
    sortAsc ? a.localeCompare(b) : b.localeCompare(a)
  );


  return (
    <div className="overall-div-for-suite">

      <PortalHeader />

      <div className="suite-hero-section">
        <img src={foreFlightBanner} alt='foreflight-banner'></img>
        <div className="dark-overlay"></div>

        <div className="suite-wrapper">
          <h1>ForeFlight</h1>
        </div>
      </div>

      <div className='suite-default-info'>

        <div className='suite-info1'>
          <h1><strong>High-Risk-Lightning™ (HRL™) data seamlessly delivered to your ForeFlight environment.</strong></h1>
          <div className='suite-info1-inner'>
            <p>Based on your selected delivery method and schedule, you’ll receive HRL™ documents that highlight significant lightning activity.</p>
            <p>These files can be downloaded and easily imported into the ForeFlight app, giving you a clear view of critical strike data within your flight planning workflow.</p>

            <img src={foreFlightGif} alt='foreflight-gif'></img>
          </div>
        </div>

        <div className='suite-info1'>
          <h2><strong>Looking for more detail?</strong></h2>
          <p>View our integration flowchart to see how it works step by step.</p>
          <button
            onClick={() => window.open(foreFlightPdf, '_blank')}
          >
            View Flowchart
          </button>
        </div>

        <div className='suite-info1'>
          <h2><strong>Organization</strong></h2>
          <p style={{ color: '#28aae1' }}>{organization}</p>
        </div>

        <div className='suite-info1'>
          <h2><strong>Data Delivery</strong></h2>
          <div className='suite-info1-inner'>
            <p style={{ color: '#28aae1' }}>Daily Email</p>
            {dailyEmail ? (
              <p>Delivered even when there are no strikes.</p>
            ) : (
              <p>Delivered only when strikes occur.</p>
            )}

          </div>

          <p>Your HRL™ data is delivered automatically based on your selected schedule.</p>
        </div>

        <div className='suite-info1'>
          <h2><strong>Area Coverage</strong></h2>
          <p style={{ color: '#28aae1' }}>{coverage_area? coverage_area: "Undefined"}</p>
        </div>

        <div className='suite-info1'>
          <h2><strong>HRL™ File Type</strong></h2>

          <div className='suite-info1-inner'>
            <p style={{ color: '#28aae1' }}>HRL™ 0 - {hrl}</p>
          </div>

          <p><strong>Significance of HRL Data</strong></p>

          <div className='suite-info1-inner'>
            <p>Strikes closer to 0 indicate higher risk and ignition potential and are visualized with warmer colors (e.g., red).</p>
            <p> Strikes closer to 100 represent lower risk and are shown in cooler colors (e.g., blue).</p>
          </div>
        </div>

        <div className='suite-info1'>
          <h2><strong>Email Recipients</strong></h2>
          <p>The following recipients are currently set to receive HRL™ data:</p>

          <div className="esri-search-container" style={{ maxWidth: '30rem', position: 'relative' }}>
            <input
              className="esri-search-input"
              type="text"
              placeholder="Search Email Address"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id='esri-name-search'
              style={{ fontSize: '1rem' }}
            />

            <IoClose
              className="clear-icon"
              style={{
                position: 'absolute',
                right: '0.75rem',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer'
              }}
              onClick={() => setSearchTerm('')}
            />

          </div>

          <div className="email-table-container">
            <table className="suite-info1-table">
              <thead>
                <tr>
                  <th>
                    <div
                      style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', cursor: 'pointer' }}
                      onClick={() => setSortAsc(prev => !prev)}
                    >
                      {/* <span>Email</span> */}
                      {sortAsc ? <RiSortAlphabetAsc /> : <RiSortAlphabetDesc />}
                    </div>
                  </th>
                </tr>
              </thead>

            </table>
            <div className="email-table-scroll">
              <table className="suite-info1-table">
                <tbody>
                  {sortedFilteredEmails.length > 0 ? (
                    sortedFilteredEmails.map((email, idx) => (
                      <tr key={idx}>
                        <td> <span style={{ color: '#28aae1', fontWeight: '600' }}>{idx + 1}.</span> {email}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>No matching emails found</td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          </div>



        </div>

      </div>

      <div className='suite-info1'>
        <h2><strong>Questions About Your HRL Delivery?</strong></h2>
        <p>Need to make changes to your recipient list?</p>
        <p>Need to adjust your delivery method or schedule?</p>
        <Link to='/fnn_portal_representative'><button>Contact Us</button></Link>

      </div>


    </div>


  )
}

export default ForeFlight